import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Link, type LinkProps, Stack } from '@mui/material';
import { type ReactNode } from 'react';
import { Link as ReactRouterLink, type LinkProps as ReactRouterLinkProps } from 'react-router-dom';

import { isDefined } from '../../utils/types.js';

interface BaseExternalLinkProps extends Pick<LinkProps, 'onClick' | 'sx'> {
  children: ReactNode;
  color?: 'inherit';
}

/**
 * Either a `href` or `to` prop must be provided.
 * `to`: Open in a new tab a path to a route in the app.
 * `href`: Open in a new tab a URL to an external page.
 */
export type ExternalLinkProps =
  | (BaseExternalLinkProps & { href: string; to?: never })
  | (BaseExternalLinkProps & { to: ReactRouterLinkProps['to']; href?: never });

export function ExternalLink(props: ExternalLinkProps) {
  const { children, to, ...linkProps } = props;

  const linkContent = (
    <Stack component="span" display="inline-flex" direction="row" gap={0.5} alignItems="center">
      {children}
      <OpenInNewOutlinedIcon fontSize="inherit" />
    </Stack>
  );

  if (isDefined(to)) {
    return (
      <Link
        {...linkProps}
        component={ReactRouterLink}
        to={to}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkContent}
      </Link>
    );
  }

  return (
    <Link {...linkProps} target="_blank" rel="noopener noreferrer">
      {linkContent}
    </Link>
  );
}
